import {SystemMemoryProps} from "../../models/SystemMemoryProps";
import {NavMenu} from "../../components/GetNavMenu";
import {Footer} from "../../components/GetFooter";
import React, {useRef, useState} from "react";
import {Button, Input, Title} from "@mantine/core";
import {updateSubmit} from "../../logic/UpdateSubmit";
import {TwoFAFormModel} from "../../models/forms/2FAFormModel";
import {twoFAForm} from "../../logic/forms/2FAForm";
import {IconKey} from "@tabler/icons";
import {FormContainer} from "../../components/form/FormContainer";
import {ApiDataHelper} from "../../data/ApiDataHelper";
import {TwoFAStatusModel} from "../../models/authentication/2FAStatusModel";

async function TwoFASubmit(body: TwoFAFormModel) {
    // Clear notification banner and set button to loading state
    updateSubmit(body.submitButton, 'Authenticating', true);
    body.setBanner(<></>)

    await twoFAForm(body);
    updateSubmit(body.submitButton, 'Authenticate', false);
}

export function Auth2FA({memory}: SystemMemoryProps) {
    const inputs = {
        code: useRef(null)
    }

    // Create navigation and notification states
    const [notification, setNotification] = useState(<></>)

    // Create submit button state with the submit button within it
    const submit = useState(
        <Button variant="light" color="indigo" radius="md" size="md" uppercase
                onClick={() => TwoFASubmit({
                    memory: {memory},
                    setBanner: setNotification,
                    submitButton: submit,
                    inputs: inputs
                })}>
            Authenticate
        </Button>
    );

    // Create the login form
    const form = (
        <>
            {notification}<br/>
            <Title align="center">Two Factor Authentication</Title>
            <Input.Label required size={"lg"}>TOTP Code</Input.Label>
            <Input
                placeholder="The time-based one-time password from your authenticator app."
                icon={<IconKey size={"1rem"}/>}
                variant="filled"
                radius="md"
                size="lg"
                ref={inputs.code}
            /><br/>
            <center>
                {submit[0]}
            </center>
        </>
    )

    // Check if the user is logged in, if not redirect to the login page
    if (!(memory[0].isSignedIn)) {
        memory[0].Router('/login');
    }

    async function has2FA() {
        const api = new ApiDataHelper({memory});
        const data = await api.Execute<TwoFAStatusModel>('/auth/2fa/status', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        // If the user has 2FA enabled, redirect to the redirect URL if it exists otherwise the dashboard
        if (data !== undefined) {
            if (data.authorised) {
                if (memory[0].URLBefore2FA !== undefined) {
                    const url = memory[0].URLBefore2FA;

                    // Clear the URLBefore2FA memory
                    memory[0].URLBefore2FA = undefined;
                    memory[1](memory[0]);

                    memory[0].Router(url);
                } else {
                    memory[0].Router('/account/dashboard');
                }
            }
        }

    }

    // Check if the user has 2FA enabled
    React.useEffect(() => { has2FA() }, [])

    return (
        <>
            <NavMenu memory={memory}></NavMenu>
            {FormContainer(form)}
            <Footer data={[]}></Footer>
        </>
    )
}